<template>
  <div class="localP">
    <div class="loginBox" ref="loginBox">
      <div class="box_right">
        <div class="right_line1">
          <div class="font1">新能智运平台运营端</div>
          <div class="xian"></div>
        </div>
        <div class="right_line2">
          <div class="input_box">
            <m-input
              v-model.trim="useinfo.username"
              :fontname="'icon-zhanghao'"
              :info="'请填写用户名'"
            ></m-input>
          </div>
          <div class="input_box">
            <m-input
              v-model.trim="useinfo.password"
              :fontname="'icon-mima'"
              :itype="passtype"
              :info="'请填写密码'"
            ></m-input>
            <img
              class="open"
              src="../assets/imgs/newlogin/login_icon_open.png"
              alt=""
              v-if="eye"
              @click="showPassword()"
            />
            <img
              class="open"
              src="../assets/imgs/newlogin/login_icon_close.png"
              alt=""
              v-else
              @click="showPassword()"
            />
          </div>
          <div class="input_box">
            <div class="input_code">
              <m-input
                v-model.trim="useinfo.captcha"
                :info="'请填写验证码'"
                :alone="'width:100%'"
              ></m-input>
            </div>
            <div class="box_image" ref="imgs"></div>
            <i class="iconfont icon-shuaxin" @click="getCode"></i>
          </div>
          <div class="input_box">
            <div class="radio_box">
              <div class="ckeck_box" @click="checked = !checked">
                <!-- <span :class="checked ? 'ischecked box' : 'box'">
                <i class="iconfont icon-xuanzhong"></i
              ></span>
              <span class="text">记住密码</span> -->
              </div>
              <div class="register">
                <span class="paswd" @click="checkpass">忘记密码?</span>
              </div>
            </div>
          </div>
          <div class="input_box">
            <div class="islogin" @click="jumphome">
              立即登录
            </div>
          </div>
        </div>
        <!-- <div class="botton_sty">
            <span class="paswd">忘记密码?</span>
            <div class="register">
              <span style="color: #acafb8">没有账号?</span>
              <span style="text-decoration: underline">立即注册</span>
            </div>
          </div> -->
      
      </div>
    </div>
    <!-- <div class="urlp">
      <img class="img" src="../assets/imgs/gongan.png" />
      <a href="https://beian.miit.gov.cn"
        >津公网安备 12019302000146号 津ICP备2021009189号</a
      >
    </div> -->
  </div>
</template>
<script>
import mInput from '@/components/mInput.vue';
import { mapMutations } from 'vuex';
import { encrypt} from '@/utils/jsencrypt'
export default {
  data() {
    return {
      pageindex: true,
      useinfo: {
        captcha: '',
        username: '',
        password: '',
        uuid: null,
      },
      passtype: 'password',
      eye: false,
      checked: false,
    };
  },
  components: {
    mInput,
  },
  mounted() {
    // this.setloginBoxSty();
    this.getCode();
    // window.addEventListener('keyup', (e) => {
    //       if (e.keyCode == 13) {
    //         this.jumphome();
    //       }
    //     });  
  },
  methods: {
    showPassword() {
      /*密码显示 */
      var me = this;
      if (me.eye) {
        me.eye = false;
        me.passtype = 'password';
      } else {
        me.eye = true;
        me.passtype = 'text';
      }
    },
    checkpass(){
      this.$message('请联系管理员')
    },
    ...mapMutations(['adduser']),
    // 计算登录窗体的宽高
    // setloginBoxSty() {
    //   let width = window.screen.width * 0.6;
    //   let height = width * 0.42;
    //   this.$refs.loginBox.style.width = width + 'px';
    //   this.$refs.loginBox.style.height = height + 'px';
    // },
    async getCode() {
      this.useinfo.captcha = '';
      this.useinfo.uuid = this.getUUID();
      const { data } = await this.$http('api1', '/captcha.jpg', 'get', {
        uuid: this.useinfo.uuid,
      });
      if (!data) return;
      // 将arraybuffer转化为图片
      let binary = '';
      const bytes = new Uint8Array(data);
      const len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      this.$refs.imgs.style = `background:url(data:image/png;base64,${window.btoa(
        binary
      )});background-size: 100% 100%;`;
    },
    getUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        return (c === 'x'
          ? (Math.random() * 16) | 0
          : 'r&0x3' | '0x8'
        ).toString(16);
      });
    },

    async jumphome() {
      if (
        this.useinfo.captcha &&
        this.useinfo.username &&
        this.useinfo.password
      ) {
        let loginform={}
        loginform.captcha=this.useinfo.captcha;
        loginform.username=this.useinfo.username;
        loginform.password=encrypt(this.useinfo.password);
        loginform.uuid=this.useinfo.uuid;
        const { data } = await this.$http(
          'api1',
          '/sys/login',
          'post',
          loginform
        );
        if (data.msg != 'success') {
          this.$message({
            type: 'warning',
            title: '提示',
            message: data.msg,
          });
          this.getCode();
          return;
        }
      
        let obj = {
          token: data.token,
          username: this.useinfo.username,
        };
        this.adduser(obj);
        // if(this.checked) document.cookie=`username=${this.useinfo.username};password=${this.useinfo.password};expires=${new Date().getTime()+30*60*60*1000};path=/`;
        this.$router.push('/home/homepage');
        if(!this.checked) {
        this.useinfo.password=""
       }
        // window.location.reload();
      } else {
        this.$message({
          type: 'warning',
          title: '提示',
          message: '请查看用户名、密码、验证码是否填写',
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.localP {
  background-image: url('../assets/imgs/newlogin/pic_login_background.png');
  overflow: scroll;
  // width: 1918.8px;
  // height: 1079.1px;
  width: 100vw;
  height: 100wh;
  display: flex;
   justify-content: center;
   align-items: center;
  .loginBox {
    // width: 1098.2px;
    // height: 654.4px;
    width: 57%;
    height: 60%;
    background-image: url('../assets/imgs/newlogin/pic_logion_truck.png');
    background-size: 100% 100%;
    display: flex;
    justify-content: flex-end;
    .box_left {
      position: relative;
      
      // width: 50%;
      
      .center_txt1 {
        position: absolute;
        left: 50%;
        top: 20%;
        transform: translate(-50%, -50%);
        font-size: 1.5rem;
        letter-spacing: 0.1em;
        white-space: nowrap;
        color: #fff;
        img {
          width: 12%;
          vertical-align: middle;
        }
      }
      .center_txt2 {
        position: absolute;
        left: 50%;
        bottom: 50%;
        font-size: 1rem;
        color: #fff;
        transform: translate(-50%, -50%);
        padding: 1%;
        letter-spacing: 0.1em;
        .border_lt,
        .border_rt,
        .border_rb,
        .border_lb {
          position: absolute;
          // width: 12%;
          padding-bottom: 10%;
        }
        .border_lt {
          top: 0;
          left: 0;
          border-left: 1px solid #fff;
          border-top: 1px solid #fff;
        }
        .border_rt {
          right: 0;
          top: 0;
          border-top: 1px solid #fff;
          border-right: 1px solid #fff;
        }
        .border_rb {
          bottom: 0;
          right: 0;
          border-bottom: 1px solid #fff;
          border-right: 1px solid #fff;
        }
        .border_lb {
          bottom: 0;
          left: 0;
          border-bottom: 1px solid #fff;
          border-left: 1px solid #fff;
        }
      }
      .center_text3 {
        position: absolute;
        left: 50%;
        width: 80%;
        transform: translateX(-50%);
        bottom: 10%;
        color: #fff;
        p {
          font-size: 80%;
        }
      }
    }
    .box_right {
      margin-top: 12%;
      margin-right: 40px;
      width: 35%;
      // width: 1098.2px;
    // height: 654.4px;
      // overflow: auto;
      .right_line1 {
        position: relative;
        width: 100%;
        height: 10%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;

        // margin-top: 60px;
        // .font2 {
        //   position: absolute;
        //   bottom: 0;
        // }
        .font1 {
          font-size: 120%;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #333333;
          text-align: center;
          // margin-top: 4rem;
        }
        .xian {
          width: 25px;
          height: 3px;
          background: #17b6a1;
        }
        // .font2 {
        //   right: 0;
        //   cursor: pointer;
        //   font-size: 0.9rem;
        //   color: #acafb8;
        // }
        // .font2:hover {
        //   color: #15357d;
        // }
      }
      .right_line2 {
        position: relative;
        box-sizing: border-box;
        padding-top: 24px;
        height: 86%;
        width: 100%;
        .input_box {
          position: relative;
          height: 10%;
          width: 100%;
          margin-bottom: 7.2%;
          .open {
            width: 1rem;
            height: 1rem;
            position: absolute;
            left:90%;
            top: 20%;
          }
          .input_code {
            position: absolute;
            height: 100%;
            width: 66%;
          }
          .box_image {
            position: absolute;
            right: 0;
            height: 100%;
            width: 30%;
            border: 1px solid #e8e8e8;
          }
          .icon-shuaxin {
            position: absolute;
            right: 0;
            top: 50%;
            font-size: 1rem;
            cursor: pointer;
            transform: translate(120%, -50%);
            color: #acafb8;
          }
          .keeppassword {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            font-size: 90%;
            color: #acafb8;
          }
          .radio_box {
            // position: relative;
            cursor: pointer;
            height: 100%;
            font-size: 90%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .ckeck_box{
              .box {
              // position: absolute;
              // top: 50%;
              transform: translateY(-50%);
              width: 13px;
              height: 13px;
              border: 1px solid #e8e8e8;
            }
            .text {
              // position: absolute;
              // top: 50%;
              // left: 23px;
              transform: translateY(-50%);
            }
            .icon-xuanzhong {
              // position: absolute;
              // top: 50%;
              // left: 50%;
              font-size: 60%;
              transform: translate(-50%, -50%);
              color: #fff;
            }
            .ischecked {
              border-color: #17b6a1;
              background: #17b6a1;
            }
            }
        
            .register {
              // position: relative;
              // top: 10px;
              // left: 210px;
              color: #17b6a1;
              .paswd {
                margin-left: 11px;
              }
            }
            
          }
        }
        .codesty {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        }
        .islogin {
          position: relative;
          text-align: center;
          color: #fff;
          cursor: pointer;
          height: 40px;
          font-size: 100%;
          font-family: Microsoft YaHei;
          font-weight: 400;
          background: linear-gradient(
            90deg,
            #f52b38 0%,
            #28b5c7 0%,
            #2ec7b5 49%,
            #34daa3 100%
          );
          box-shadow: 0px 2px 7px 0px rgba(19, 170, 150, 0.35);
          border-radius: 28px;
          line-height: 40px;
        }
      }
      .botton_sty {
        position: relative;
        width: 100%;
        .register,
        .paswd {
          position: absolute;
          color: #17b6a1;
          white-space: nowrap;
          font-size: 0.9rem;
          cursor: pointer;
        }
        .register {
          right: 0;
        }
      }
    }
  }
  .urlp {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    font-size: 16px;
    bottom: 100px;
    .img {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
    a {
      padding-left: 30px;
      text-decoration: none;
      color: #acafb8;
      letter-spacing: 0.1em;
    }
    a:hover,
    a:active {
      color: #17b6a1;
    }
  }
}
</style>
